import { useSession } from "contexts/session-context"
import { useRouteMatch } from "react-router-dom"
import { dlTrackEvent } from "components/dataLayer/dataLayer"
import { useLocalStorage } from "react-use"
import useRouter from "hooks/use-router"
import CONFIGS from 'build/Config'
import useMainClass from "hooks/use-main-cass"
import { useState } from "react"
import SurveyOnBoarding from "./components/surveyOnBoarding"
import SurveyCover from "./components/surveyCover"
import Survey from "."

function SurveyQr() {

  const [{ user }] = useSession()
  const route = useRouteMatch<{ id: string }>()
  const { history } = useRouter()
  const [popUp, setPopUp] = useLocalStorage('triviaQrPopUp', false)
  const [cover, setCover] = useState(true)
  useMainClass('survey-qr')
  useMainClass('survey-qr-' + route.params.id)

  const handleClick = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Survey - Comencemos', value: '10' })
    dlTrackEvent('user_interaction', { action: 'click', element: 'comencemos', section: 'survey' })
    if (!user) {
      localStorage.setItem('internal_redirect', `/survey/qr/${route.params.id}`)
      return history.push('/start')
    }

    if (!popUp && CONFIGS?.triviaQrPopUp) {
      setPopUp(true)
    }
  }

  const handleCover = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Survey - Si, Jalo', value: '10' })
    dlTrackEvent('user_interaction', { action: 'click', element: 'Si, Jalo', section: 'survey' })
    setCover(false)
  }

  if (!user || (!popUp && CONFIGS?.triviaQrPopUp)) {
    return <SurveyOnBoarding handleClick={handleClick} />
  }

  if (THEME === "indio" && cover && ['5', '6'].includes(route.params.id)) {
    return <SurveyCover handleClick={handleCover} />
  }

  return (
    <Survey isDirectAccess={true} />
  )
}

export default SurveyQr